import React, { useCallback } from "react"
import "rc-slider/assets/index.css"

import { ViewerBackgroundType, ViewerFontSize, ViewerFontType } from "types"
import styles from "./index.module.scss"

export type SettingsProps = {
  backgroundType: ViewerBackgroundType
  fontType: ViewerFontType
  fontSize: ViewerFontSize
  onChangeBackgroundType: (backgroundType: ViewerBackgroundType) => void
  onChangeFontType: (fontType: ViewerFontType) => void
  onChangeFontSize: (fontSize: ViewerFontSize) => void
  onResize: () => void
}

const Settings: React.FC<SettingsProps> = ({
  backgroundType,
  fontType,
  fontSize,
  onChangeBackgroundType,
  onChangeFontSize,
  onChangeFontType,
  onResize,
}) => {
  const handleChangeBackgroundType = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChangeBackgroundType(e.target.value as ViewerBackgroundType)
    },
    [onChangeBackgroundType],
  )

  const handleChangeFontType = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChangeFontType(e.target.value as ViewerFontType)
    },
    [onChangeFontType],
  )

  const handleChangeFontSize = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChangeFontSize(e.target.value as ViewerFontSize)
      onResize()
    },
    [onChangeFontSize, onResize],
  )

  return (
    <>
      <div className={styles.title}>設定</div>
      <div className={styles.subTitle}>文字の大きさ</div>
      <fieldset className={styles.fontSize}>
        <div className={styles.fontSizeContainer}>
          <input
            id="fontSizeSmall"
            className={styles.fontSizeInput}
            checked={fontSize === ViewerFontSize.Small}
            name="fontSize"
            type="radio"
            value={ViewerFontSize.Small}
            onChange={handleChangeFontSize}
          />
          <label
            className={`${styles.fontSizeLabel} ${styles.mincho}`}
            htmlFor="fontSizeSmall"
          >
            小
          </label>
          <input
            id="fontSizeMedium"
            className={styles.fontSizeInput}
            checked={fontSize === ViewerFontSize.Medium}
            name="fontSize"
            type="radio"
            value={ViewerFontSize.Medium}
            onChange={handleChangeFontSize}
          />
          <label className={styles.fontSizeLabel} htmlFor="fontSizeMedium">
            中
          </label>
          <input
            id="fontSizeLarge"
            className={styles.fontSizeInput}
            checked={fontSize === ViewerFontSize.Large}
            name="fontSize"
            type="radio"
            value={ViewerFontSize.Large}
            onChange={handleChangeFontSize}
          />
          <label className={styles.fontSizeLabel} htmlFor="fontSizeLarge">
            大
          </label>
        </div>
      </fieldset>
      <div className={styles.subTitle}>文字の種類</div>
      <fieldset className={styles.fontType}>
        <div className={styles.fontTypeContainer}>
          <input
            id="fontTypeMincho"
            className={styles.fontTypeInput}
            checked={fontType === ViewerFontType.Mincho}
            name="fontType"
            type="radio"
            value={ViewerFontType.Mincho}
            onChange={handleChangeFontType}
          />
          <label
            className={`${styles.fontTypeLabel} ${styles.mincho}`}
            htmlFor="fontTypeMincho"
          >
            明朝
          </label>
          <input
            id="fontTypeGothic"
            className={styles.fontTypeInput}
            checked={fontType === ViewerFontType.Gothic}
            name="fontType"
            type="radio"
            value={ViewerFontType.Gothic}
            onChange={handleChangeFontType}
          />
          <label className={styles.fontTypeLabel} htmlFor="fontTypeGothic">
            ゴシック
          </label>
        </div>
      </fieldset>
      <div className={styles.subTitle}>背景の種類</div>
      <fieldset className={styles.backgroundType}>
        <div className={styles.backgroundTypeContainer}>
          <input
            id="backgroundTypeCream"
            className={styles.backgroundTypeInput}
            checked={backgroundType === ViewerBackgroundType.Cream}
            name="backgroundType"
            type="radio"
            value={ViewerBackgroundType.Cream}
            onChange={handleChangeBackgroundType}
          />
          <label
            className={`${styles.backgroundTypeLabel} ${styles.cream}`}
            htmlFor="backgroundTypeCream"
          >
            クリーム
          </label>
          <input
            id="backgroundTypeWhite"
            className={styles.backgroundTypeInput}
            checked={backgroundType === ViewerBackgroundType.White}
            name="backgroundType"
            type="radio"
            value={ViewerBackgroundType.White}
            onChange={handleChangeBackgroundType}
          />
          <label
            className={`${styles.backgroundTypeLabel} ${styles.white}`}
            htmlFor="backgroundTypeWhite"
          >
            ホワイト
          </label>
          <input
            id="backgroundTypeBlack"
            className={styles.backgroundTypeInput}
            checked={backgroundType === ViewerBackgroundType.Black}
            name="backgroundType"
            type="radio"
            value={ViewerBackgroundType.Black}
            onChange={handleChangeBackgroundType}
          />
          <label
            className={`${styles.backgroundTypeLabel} ${styles.black}`}
            htmlFor="backgroundTypeBlack"
          >
            ブラック
          </label>
        </div>
      </fieldset>
    </>
  )
}

export default Settings
